import React from 'react';
import { Icon } from '../../../components/BillingMDC';
import Switch from '../../../components/Switch';
import HorizontalLabelValueBar from '../../common/horizontalLabellValueBar';

const AreaBody = ({ dataList, onRowClick ,handleInputChange }) => (
  <tbody>
    {dataList.map((data, index) => (
      <tr>
        <td className='left-align'>{data.title}</td>
        <td className='text-center'>
          <div className='form-switchs '>
            <HorizontalLabelValueBar
              value={
                <Switch
                  onToggle={(checked, event) => handleInputChange('status',checked, data?.idAreas)}
                  checked={data.active}
                  id={`switch-${data.idAreas}`}
                  className='cursor-pointer '
                />
              }
            />
          </div>
        </td>
        <td className='right-align edit'>
          <Icon name='edit' onClick={() => onRowClick(data,'Update')} />
        </td>
      </tr>
    ))}
  </tbody>
);

const areaConfig = [
  {
    id: 1,
    label: 'name',
    title: 'Area',
    className: '',
    sortable: false,
  },
  {
    id: 2,
    label: 'status',
    title: 'Status',
    className: ' text-center',
    sortable: false,
  },
  {
    id: 3,
    label: '',
    title: '',
    className: ' edit',
    sortable: false,
  },
];

const formValidationFieldList = [{ title: 'title' }];

const config = {
  header: areaConfig,
  getTableBody: AreaBody,
  formValidationFieldList,
};

export default config;
